import ReactSlidingPane from 'components/slidingpane/component'
import { connect } from 'react-redux'
import { setSidebarVisibility } from 'components/slidingpane/reducer'

const mapStateToProps = ({ sidebar }) => {
  return {
    isOpen: sidebar.visibility
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onRequestClose: () => dispatch(setSidebarVisibility())
  }
}

const container = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReactSlidingPane)

export { container as Sidebar }
